import React from 'react';
import { Dialog, DialogActions, DialogContent, Button, styled, Stack } from '@mui/material';
import { styled as materialStyled } from '@mui/material/styles';
import { theme } from '../../../theme/theme';

interface ConfirmationModalProps {
  open: boolean;
  onConfirm: () => void;
  onCancel: () => void;
  onDismiss: () => void;
}

export const CustomButton = materialStyled(Button)(() => ({
  borderRadius: '8px',
  padding: '4px 8px',
  textAlign: 'center',
  textTransform: 'none',
  fontFamily: 'Satoshi',
  fontSize: 18,
  fontStyle: 'normal',
  fontWeight: 600,
  lineHeight: 'normal',
  height: '40px',
  color: theme.palette.white.main,
}));

const StyledDialogContent = styled(DialogContent)({
  textAlign: 'center',
  textTransform: 'none',
  fontFamily: 'Satoshi',
  fontSize: 22,
  fontStyle: 'normal',
  fontWeight: 600,
  lineHeight: 'normal',
});

export const GemPassportConfirmationModal: React.FC<ConfirmationModalProps> = ({
  open,
  onConfirm,
  onCancel,
  onDismiss,
}) => (
  <Dialog
    open={open}
    onClose={onDismiss}
    maxWidth="xs"
    sx={{ padding: '0px 20px' }}
    PaperProps={{ sx: { borderRadius: '12px' } }}
  >
    <DialogContent>
      <StyledDialogContent>Display both User-Input values and AI-Inferred values?</StyledDialogContent>
    </DialogContent>
    <DialogActions sx={{ margin: '30px 0' }}>
      <Stack direction="column" spacing={2} sx={{ width: '100%' }}>
        <CustomButton
          variant="contained"
          color="primary"
          fullWidth
          onClick={onConfirm}
          sx={{
            backgroundColor: theme.palette.shades.primaryBrightDark,
          }}
        >
          Yes
        </CustomButton>
        <CustomButton
          onClick={onCancel}
          color="primary"
          sx={{
            border: `1px solid ${theme.palette.shades.primaryBrightDark}`,
            color: theme.palette.shades.primaryBrightDark,
          }}
        >
          No
        </CustomButton>
      </Stack>
    </DialogActions>
  </Dialog>
);
